import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NewsfeedService } from './../_services/newsfeed.service';

@Component({
  selector: 'app-polls',
  templateUrl: './polls.component.html',
  styleUrls: ['./polls.component.scss']
})

export class PollsComponent implements OnInit {

  @Input('poll-id') pollID;
  @Input('user') user;
  @Output() likeList: EventEmitter<any> = new EventEmitter();
  poll = null;

  constructor(private _newsFeedService: NewsfeedService) { }

  ngOnInit() {
    if (this.pollID != null) this.getPoll(this.pollID);
  }

  getPoll(poll_id){
    this._newsFeedService.getPoll(poll_id, this.user.id).subscribe(state => {
      this.poll = state;
      this.poll.total_votes = this.poll.options.reduce((acc,option) => acc + parseInt(option.votes),0);
      this.poll.options.forEach(option => {
        option.percentage = Math.round((parseInt(option.votes)/this.poll.total_votes)*100);
      });
    });
  }

  castVote(choice){
    this._newsFeedService.votePoll(this.pollID, this.user.id, choice).subscribe(state => {
      this.poll.options[choice - 1].votes = parseInt(this.poll.options[choice-1].votes) + 1;
      this.poll.total_votes++;
      this.poll.options.forEach(option => {
        option.percentage = Math.round((parseInt(option.votes)/this.poll.total_votes)*100);
      });
      this.poll.can_vote = false;
    });
  }

  showLikeList(choice, label){
    this.likeList.emit({
      id: this.pollID,
      choice,
      header: label+' Votes'
    });
  }

}
